{
	"label": "Categorias",
	"addAll": "Adicionar todos",
	"removeAll": "Remover todos"
}
